







































import { Component, Vue } from 'vue-property-decorator'
import AdminPricingCalendar from '../../components/global/AdminPricingCalendar.vue'
import CalendarTemplateList from '@/components/admin/calendar-templates/calendar-template-list.vue'
import CalendarTemplateProductAssignmentList from '@/components/admin/calendar-templates/calendar-template-product-assignment-list.vue'

@Component({
    components: {
        AdminPricingCalendar,
        CalendarTemplateList,
        CalendarTemplateProductAssignmentList
    }
})
export default class PricingCalendar extends Vue { }
